import { render, staticRenderFns } from "./ListPlegable.vue?vue&type=template&id=514e105e&scoped=true"
import script from "./ListPlegable.vue?vue&type=script&lang=js"
export * from "./ListPlegable.vue?vue&type=script&lang=js"
import style0 from "./ListPlegable.vue?vue&type=style&index=0&id=514e105e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e105e",
  null
  
)

export default component.exports